module.exports = __webpack_public_path__ + "static/img/Back-to-home.6634a177.png";